import React, { useState, useEffect } from "react";
import { DateTimePicker } from "react-widgets";
import Select from "react-select";
import {
    mdiHome,
    mdiChevronDoubleRight,
    mdiDelete,
    mdiCartArrowDown,
    mdiPlus,
    mdiPrinter,
    mdiCartOutline,
    mdiPencil,
    mdiPlusCircleOutline,
} from "@mdi/js";
import Icon from "@mdi/react";
import iconCustomer from "../../../Resources/ImagesNew/Group2196.png";
import { convertToNumber } from "utils/currencyFormat";
import moment from "moment";
import { AutocompleteDiaChiGiaoHang } from "./AutocompleteDiaChiGiaoHang";
import DatHangApi from "../../../service/DatHang/DatHangApi";
import { MultiSelect } from "react-multi-select-component";
import { pushNotification } from "utils/notifications";
export const ThongTinKhachHang = ({
    isShowTinhThanh,
    dataBanHang,
    setDataBanHang,
    roleHanThanhToan,
    DHQuaHanThanhToan,
    setDHQuaHanThanhToan,
    activePage,
    setPageActive,
    disEditKH,
    listNVKD,
    setListNVKD,
    HienThiChietKhau,
    HienThiChietKhauCoBien,
    setListChietKhauNhomKH,
    updateTienCKNhom,
    setFocusKho,
    setDisEditKH,
    EditID,
    disEditAll,
    isShowNVKDNew,
    listNVKDNew,
    setListNVKDNew,
}) => {


    const onChangeText = (field, e) => updateStateThongTin(field, e.target.value);
    const updateStateThongTin = (field, value) => {
        const thongtin = { ...dataBanHang };
        thongtin[field] = value;
        setDataBanHang(thongtin);
    };

    if (dataBanHang.lstChiTiet && dataBanHang.lstChiTiet.length > 0) {
        dataBanHang.lstChiTiet.map((category, index) => {
            if (category.IdPhieuGiaoNhan > 0) {
                setDisEditKH(true);
            }
        });
    }


    return (
        <>
            <div className="row">
                <div className="col-lg-4">
                    <h2 class="title-detail-new">
                        <img src={iconCustomer} alt="#" />
                        Thông tin người đặt hàng
                    </h2>
                </div>
            </div>
            <div class="row select-address">
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main">Họ và tên <span style={{ color: "red" }}>*</span></label>
                            <input
                                type="text"
                                class="form-control"
                                value={dataBanHang.CustomerName}
                                onChange={(e) => onChangeText("CustomerName", e)}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main" for="eventRegInput2">
                                Địa chỉ <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                value={dataBanHang.CustomerAddress}
                                onChange={(e) => onChangeText("CustomerAddress", e)}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label
                                class="label-control text-left-main"
                                for="eventRegInput2"
                            >
                                Điện thoại <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder=""
                                value={dataBanHang.Phone}
                                onChange={(e) => onChangeText("Phone", e)}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group  align-centerNew  ">
                        <div class="form-new-input-left">
                            <label class="label-control text-left-main" for="eventRegInput2">
                                Địa chỉ giao hàng <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                value={dataBanHang.DiaChiGiaoHang}
                                onChange={(e) => onChangeText("DiaChiGiaoHang", e)}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};
